import GenericModel from './generic-model';
import LoggedAction from './logged-action';
import RegisteredAction from './registered-action';

export default class Quotation extends GenericModel {
  approved?: boolean;
  approvalReasons?: string;
  noteForCustomer?: string;
  approvalRegistration?: LoggedAction;
  disapprovalRegistration?: LoggedAction;
  sentRegistration?: LoggedAction;
  registeredActions?: RegisteredAction[];
}
